import { useFormikContext } from 'formik';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { Col, FormCheck, Row } from 'react-bootstrap';
import { CellProps } from 'react-table';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import { TableCustomCell } from 'src/app/modules/component/table/components/TableCustomCell';
import { TableCustomHeader } from 'src/app/modules/component/table/components/TableCustomHeader';
import { TableCustom } from 'src/app/modules/component/table/table-custom/TableCustom';
import TableInputField from './TableInputField';

const TableView = ({
	data,
	updateRowData,
	formValues,
}: {
	data: any[];
	updateRowData: (name: string, value: any, otherValues?: any) => void;
	formValues?: any;
}) => {
	const COLUMNS = useMemo(
		() => [
			{
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="STT"
						className="text-center text-white px-3 min-w-30px"
					/>
				),
				id: 'STT',
				Cell: ({ ...props }) => (
					<TableCustomCell
						className="text-center"
						data={String(props.row.original.index)}
					/>
				),
			},
			{
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="Ký hiệu"
						className="text-center text-white px-3 min-w-200px"
					/>
				),
				id: 'kyHieu',
				Cell: ({ row: { original } }: CellProps<any>) => (
					<TableCustomCell
						className="text-center"
						data={
							<div className="d-flex align-items-center justify-content-between">
								<span className="d-flex align-items-center">
									<i className="bi bi-dot text-dark fs-2"></i>
									{original?.label}
								</span>
								<span className="spaces ml-4 pe-8">
									<FormCheck
										type="checkbox"
										checked={
											formValues[original?.checkboxField] &&
											formValues[original?.checkboxField] !== '0'
										}
										onChange={(e: ChangeEvent<HTMLInputElement>) => {
											const checked = e.target.checked;
											updateRowData(original.checkboxField, checked, {
												[original?.textboxField]: checked
													? formValues[original?.textboxField]
													: null,
											});
										}}
									/>
								</span>
							</div>
						}
					/>
				),
			},
			{
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="Thời gian (tính theo tháng)"
						className="text-center text-white px-3 min-w-30px"
					/>
				),
				id: 'thoiGian',
				Cell: ({ row: { original } }: CellProps<any>) => (
					<TableCustomCell
						className="text-center"
						data={
							<TableInputField
								name={original?.textboxField}
								fieldValue={formValues[original?.textboxField]}
								updateRowData={updateRowData}
								disabled={
									!formValues[original?.checkboxField] ||
									formValues[original?.checkboxField] === '0'
								}
							/>
						}
					/>
				),
			},
		],
		[formValues, updateRowData]
	);

	return (
		<div>
			<TableCustom
				columns={COLUMNS}
				data={data}
				selectionMode="singleNoRadioButton"
				tableOptions={{
					updateRowData,
				}}
			/>
		</div>
	);
};

const DacDiemLienQuanBenh = () => {
	const { setFieldValue, values } = useFormikContext<any>();

	const TABLE_VALUE = [
		{
			label: 'Dị ứng',
			checkboxField: 'medicalHistoryAllergy',
			textboxField: 'medicalHistoryAllergyMonth',
		},
		{
			label: 'Ma túy',
			checkboxField: 'medicalHistoryDrug',
			textboxField: 'medicalHistoryDrugMonth',
		},
		{
			label: 'Rượu bia',
			checkboxField: 'medicalHistoryAlcohol',
			textboxField: 'medicalHistoryAlcoholMonth',
		},
		{
			label: 'Thuốc lá',
			checkboxField: 'medicalHistoryTobacco',
			textboxField: 'medicalHistoryTobaccoMonth',
		},
		{
			label: 'Thuốc lào',
			checkboxField: 'medicalHistoryStrongTobacco',
			textboxField: 'medicalHistoryStrongTobaccoMonth',
		},
		{
			label: 'Khác',
			checkboxField: 'medicalHistoryOther',
			textboxField: 'medicalHistoryOtherMonth',
		},
	];

	const TABLE_DATA = TABLE_VALUE.map((item, index) => ({
		...item,
		index: index + 1,
		checked: false,
	}));

	const [data, setData] = useState<any>({});

	useEffect(() => {
		if (values?.dacDiemLienQuanBenhResult) {
			setData(values.dacDiemLienQuanBenhResult);
		}
	}, [values?.dacDiemLienQuanBenhResult]);

	const updateRowData = (name: string, value: any, otherValues: any) => {
		const newValue = {
			...data,
			...otherValues,
			[name]: value,
		};
		setData(newValue);
		setFieldValue('dacDiemLienQuanBenh', newValue);
	};

	return (
		<Row className="spaces pt-10 pl-4">
			<Col sm={12}>
				<LabelRequired label="Đặc điểm liên quan bệnh:" className="spaces pb-4" />
			</Col>
			<Col sm={6}>
				<TableView
					data={TABLE_DATA.slice(0, TABLE_DATA.length / 2)}
					updateRowData={updateRowData}
					formValues={data}
				/>
			</Col>
			<Col sm={6}>
				<TableView
					data={TABLE_DATA.slice(TABLE_DATA.length / 2)}
					updateRowData={updateRowData}
					formValues={data}
				/>
			</Col>
		</Row>
	);
};

export default DacDiemLienQuanBenh;
